function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M38 18a4 4 0 014 4v20a4.002 4.002 0 01-3 3.874V46a2 2 0 01-2 2h-4a2 2 0 01-2-2H18a2 2 0 01-2 2h-4a2 2 0 01-2-2 4 4 0 01-4-4V22a4 4 0 014-4h28zm-2 12H12v10a2 2 0 001.85 1.995L14 42h20a2 2 0 001.995-1.85L36 40V30zm-2-8H14a2 2 0 00-1.995 1.85L12 24v2h24v-2a2 2 0 00-2-2zm4-20a4 4 0 014 4v6a4 4 0 01-4 4H10a4 4 0 01-4-4V6a4 4 0 014-4h28zM15 6a3 3 0 100 6 3 3 0 000-6z",
  fill: "#262626"
}));

var SvgAddOnOvenXLarge = function SvgAddOnOvenXLarge(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgAddOnOvenXLarge;